import React, {ReactNode} from "react";

export default function Paragraph({children, className}: { children: ReactNode, className?: string }) {
    return <>
        <p className={`text-lg leading-8 text-gray-600 ${className || ''}`}>{children}</p>
    </>
}

export function HeadlineParagraph({children}: { children: ReactNode }) {
    return <>
        <p className="text-base font-semibold leading-7 text-green-600">{children}</p>
    </>
}